import React from "react"
import { CTAContainer, CTATitle } from "./single-cta.style"
import ButtonLink from "../btn-collections/btn-collections.component"
import dataLayerHelper from "../../helpers/datalayer.helper"

const SingleCTA = ({ ctaTitle, btnText, url, gtmData }) => {
  return (
    <CTAContainer>
      <CTATitle>{ctaTitle}</CTATitle>
      <ButtonLink
        internal
        url={url}
        onClick={() => {
          dataLayerHelper({
            event: gtmData.event,
            action: gtmData.action,
            label: gtmData.label,
            location: gtmData.location,
          })
        }}
      >
        {btnText}
      </ButtonLink>
    </CTAContainer>
  )
}

export default SingleCTA
